import type { IconProps } from '@/shared/ui/icons/types';

export const IdCardIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <circle cx="8" cy="11" r="2" />
    <path d="M5 16a3 3 0 0 1 6 0" />
    <path d="M14 9h5" />
    <path d="M14 13h5" />
  </svg>
);
